var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{class:[_vm.$style.root],style:({
    overflow: 'auto',
    maxHeight: `${_vm.tableHeight}px`
  }),attrs:{"fluid":"","fill-height":"","pa-0":""}},[_c('v-row',{staticClass:"fill-height",attrs:{"no-gutters":""}},[_c('SmsMessageForm')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }